/**
 * @ngdoc component
 * @name westBerkshireEvents.ticketTypeQuestions:wbTicketTypeQuestions
 * 
 * @description 
 * Applies filters to the custom booking questions to distingush between adult ticket type and child ticket type questions
 */

angular.module('westBerkshireEvents.ticketTypeQuestions').filter('wbTicketTypeQuestions', function () {
    const adultRegex = new RegExp('(Adult)');
    const childRegex = new RegExp('(Child)');

    return function (questions, ticketType) {
        // If questions is not defined, just return
        if (!questions) {
            return;
        }

        if (ticketType) {
            if (ticketType.toLowerCase().indexOf('adult') >= 0) {
                // This is an adult ticket - remove child only questions
                return questions.filter(question => {
                    return !childRegex.test(question.name);
                });
            }

            if (ticketType.toLowerCase().indexOf('child') >= 0) {
                // This is a child ticket - remove adult only questions
                return questions.filter(question => {
                    return !adultRegex.test(question.name);
                });
            }
        }

        // This is a general ticket - return all questions
        return questions;
    };
});


// WEBPACK FOOTER //
// src/public/javascripts/custom-questions/custom_questions.filter.js